// extracted by mini-css-extract-plugin
module.exports = {"heading":"SuccessModal_heading__MaQFJ","text":"SuccessModal_text__28R1r"};